import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';

/**
 * Vehicle revenue KPI DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class KpiVehicleRevenueDto {
	periodDays!: number;
	rentalRevenue!: number;
	totalRevenue!: number;
}
